import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { PartnersTrust } from "../../../components/PartnersTrust";

import * as main from "./styles/main.module.scss";
import * as screen1 from "./styles/screen1.module.scss";
import * as invitation from "./styles/invitation.module.scss";
import * as target from "./styles/target.module.scss";
import * as reg from "./styles/reg.module.scss";

const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">

        <HeaderLogoAndTel/>

        <div className={screen1.screen1__content}>
          <h1 className={screen1.screen1__title}>
            Экспресс-курс <br/> "Ваш ребенок может учиться самостоятельно!"
            <span className={screen1.screen1__subtitle}>
              4&nbsp;урока с&nbsp;видео и&nbsp;аудио-материалами, а&nbsp;также полезные статьи.
            </span>
          </h1>

          <div className={screen1.screen1__descBox}>
            <div className={screen1.screen1__desc}>
              Посмотрите 4&nbsp;коротких видео и&nbsp;вы узнаете, как сделать так,
              чтобы ребенок учился хорошо, без&nbsp;напоминаний и&nbsp;вашего контроля, а&nbsp;также что нужно делать
              ребенку, чтобы поступить
              в&nbsp;любой ВУЗ на&nbsp;бюджет без&nbsp;репетиторов.

              <div className={`${main.btnBlock} ${screen1.screen1__btn}`}>
                <a href="#registration" data-target="#registration" className={main.mainBtn}>
                  <span>Смотреть видео</span>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </header>
  );
};

const Invitation = () => {
  return (
    <section className={invitation.invitation}>
      <div className="container">

        <div className={main.mainTitle}>Приглашение от&nbsp;автора:</div>

        <div className={invitation.videoBlock}>
          <div className={invitation.video}>
            <iframe
              src="https://65395.servicecdn.ru/videos/65395_qvZLWO7P2bPAFGg9"
              title={"Приглашение от автора"}
              allow="autoplay; fullscreen"
              allowFullScreen/>
          </div>
        </div>

        <div className={`${main.btnBlock} ${invitation.invitation__btn}`}>
          <a href="#registration"data-target="#registration" className={main.mainBtn}>
            <span>Узнать решение</span>
          </a>
        </div>

      </div>
    </section>
  );
};

const Target = () => {
  return (
    <section className={target.target}>
      <div className="container">

        <div className={main.mainTitle}>
          Для кого эта серия видео:
        </div>

        <div className="row">
          <div className={`col-12 col-lg-6 ${target.target__col}`}>
            <div className={target.target__item}>
              <div className={`${target.target__itemHead} ${target.target__itemHead1}`}></div>
              <div className={target.target__itemBody}>
                <div className={target.target__itemText}>
                  Для занятых родителей, которым некогда смотреть длинные видео
                </div>
              </div>
            </div>
          </div>

          <div className={`col-12 col-lg-6 ${target.target__col}`}>
            <div className={target.target__item}>
              <div className={`${target.target__itemHead} ${target.target__itemHead2}`}></div>
              <div className={target.target__itemBody}>
                <div className={target.target__itemText}>
                  Для подростков, которые хотят самостоятельно поступить в любой ВУЗ без богатых родителей
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

const Reg = ({ widget }) => {
  return (
    <section className={reg.reg} id="registration">
      <div className="container">

        <div className="row">
          <div className="col-12 col-lg-6"></div>

          <div className="col-12 col-lg-6">
            <div className={reg.regBox}>
              <div className={reg.regBox__head}>
                Регистрация
              </div>
              <div className={reg.regBox__body}>
                { widget }
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

const TITLE = 'Экспресс-курс Ваш ребенок может учиться самостоятельно! | Центр образовательных технологий Advance';
const DESCRIPTION = 'Экспресс-курс Ваш ребенок может учиться самостоятельно! | Центр образовательных технологий Advance ✅ Уникальные методики обучения ✅ Эффективное запоминание материала ✅ 100% результат ☝️ Заходите!';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  { widget=(<GetCourseWidget hash={'47b2531b4b3ddc9ca9b24309f20b2fe2b15499b5'} id={'227119'} />) }
) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: '"Montserrat", sans-serif' }}>
      <Screen1/>
      <Invitation/>
      <Target/>
      <PartnersTrust ttlName={main.mainTitle}/>
      <Reg widget={widget}/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);

export default Page;
